import { PcbNodeTypes } from "@buildwithflux/models";
import { wipeLocalRulesFromNodeType } from "./ruleMigrations";
import { rulesetMigrationRemoveRulesFromNodeType } from "./rulesetMigrations";
const keepoutRuleKeys = ["keepOut", "minKeepOut", "maxKeepOut", "keepIn", "minKeepIn", "maxKeepIn"];
const migrationDescInfoString = "This ruleset was automatically split in two by the system to accommodate new functionality for Keep Outs.";
const ruleNameASuffix = "(keepouts removed from nets)";
// Remove all keepout rules from nets
export function removeAllKeepoutsFromNets(pcbLayoutNodes, pcbLayoutRuleSets) {
    // Wipe all keepout local rules on nets
    const newPcbLayoutNodes = wipeLocalRulesFromNodeType(PcbNodeTypes.net, keepoutRuleKeys, pcbLayoutNodes);
    // Fix all rulesets
    const newPcbLayoutRuleSets = rulesetMigrationRemoveRulesFromNodeType(pcbLayoutRuleSets, "net", keepoutRuleKeys, migrationDescInfoString, ruleNameASuffix);
    return { pcbLayoutNodes: newPcbLayoutNodes, pcbLayoutRuleSets: newPcbLayoutRuleSets };
}
//# sourceMappingURL=keepoutNetMigration.js.map